import * as idEndpoints from './id';
import { root } from './transcript';

export const transcript = {
  ...root,
  id: {
    ...idEndpoints.id,
  },
};
